<template>
  <div
    class="vhsaas-chat-msg-item__wrapper"
    v-if="
      roleName != 2 ||
      source.join_id == joinId ||
      (source.answer && source.answer.join_id == joinId) ||
      !isOnlyMine
    "
  >
    <div class="vhsaas-chat-msg-item clearfix">
      <!-- 头像 -->
      <div class="vhsaas-chat-msg-item__avatar">
        <img
          class="msg-item__avatar-img"
          :src="source.avatar ? source.avatar : defaultAvatar"
          alt
        />
      </div>
      <div class="vhsaas-chat-msg-item__content">
        <!-- 昵称和角色 -->
        <p class="msg-item__content-name clearfix">
          <span class="msg-item_content-name-nick">
            {{ source.nick_name }}
          </span>

          <span class="msg-item__content-time">{{ source.created_time.slice(-8) }}</span>
        </p>
        <!-- 文本 -->
        <p
          v-if="source.content"
          class="msg-item__content-body__content"
          v-html="source.answer ? msgContent : mineContent"
        ></p>
        <template v-if="source.answer">
          <div class="msg-item__content-hr"></div>
          <div class="vhsaas-msg-item__qa-content clearfix">
            <!-- 头像 -->
            <div class="vhsaas-chat-msg-item__avatar">
              <img class="msg-item__avatar-img" :src="source.answer.avatar || defaultAvatar" alt />
            </div>
            <div class="vhsaas-chat-msg-item__content reply">
              <!-- 昵称和角色 -->
              <p class="msg-item__content-name clearfix">
                <span class="msg-item_content-name-nick">{{ source.answer.nick_name }}</span>
                <span class="msg-item_content-name-role" :class="source.answer.role_name">
                  {{ source.answer.role_name | roleFilter }}
                </span>
                <!-- <span class="msg-item_content-name-role" :class="source.answer.role_name">
                {{ source.role_name | roleFilter(this) }}
              </span> -->
              </p>
              <!-- 文本 -->
              <p
                v-if="source.answer.content"
                class="msg-item__content-body__content"
                v-html="answerContent"
              ></p>
            </div>
          </div>
        </template>
        <p :class="['msg-content_same', { active: source.like_status == 1 }]">
          <span
            @click="roleName == 2 && setSameQ(source)"
            class="same_count"
            :class="{ disabled: roleName != 2 }"
          >
            <b :class="['effect', { active: showEffect }]">
              {{ source.like_status == 1 ? '+' : '-' }}1
            </b>
            <i
              :class="[
                'normal-like',
                'vh-saas-iconfont',
                source.like_status == 1 && !showEffect ? 'vh-saas-fill-Like1' : 'vh-saas-line-Like'
              ]"
            >
              <i
                class="vh-saas-iconfont vh-saas-fill-Like1 effect-like"
                :class="{ active: showEffect && source.like_status == 1 }"
              ></i>
            </i>
            {{ $t('chat.chat_1100') }}{{ source.like_count || 0 }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { defaultAvatar } from '@/app-shared/utils/ossImgConfig';
  import { urlToLink } from '@/app-shared/utils/common';
  import { useQaServer } from 'middle-domain';
  import { throttle } from 'lodash';
  export default {
    props: {
      source: {
        type: Object,
        required: true,
        default: () => {}
      },
      isOnlyMine: {
        default: false
      },
      joinId: {},
      roleName: {
        require: true
      },
      defaultAvatar: {
        default: defaultAvatar
      },
      checkLogin: {}
    },
    data() {
      return {
        msgContent: '',
        answerContent: '',
        mineContent: '',
        showEffect: false
      };
    },
    computed: {
      customRoleName() {
        return this.$domainStore.state.roomBaseServer.customRoleName;
      }
    },
    created() {
      this.urlToLink = urlToLink('', {
        aClassNameStr: 'url-content-link'
      });
    },
    mounted() {
      this.handleAnswerContent();
      this.handleMsgContent();
    },
    methods: {
      handleMsgContent() {
        if (this.source.content) {
          this.msgContent = `<span class="msg-item__qa-flag">${this.$t(
            'chat.chat_1040'
          )}&nbsp;</span> ${this.urlToLink(this.source.content)}`;
          this.mineContent = this.urlToLink(this.source.content);
        }
      },
      handleAnswerContent() {
        if (this.source.answer && this.source.answer.content) {
          if (this.source.answer.content == '直播中回复') {
            this.answerContent = `<span class="msg-item__qa-flag color-e6e">${this.$t(
              'chat.chat_1086'
            )}</span>`;
          } else if (this.source.answer.is_open == 0) {
            this.answerContent = `<span class="msg-item__qa-flag">${this.$t(
              'chat.chat_1077'
            )}&nbsp;</span>${this.urlToLink(this.source.answer.content)}`;
          } else {
            this.answerContent = `<span class="msg-item__qa-flag">${this.$t(
              'chat.chat_1041'
            )}&nbsp;</span>${this.urlToLink(this.source.answer.content)}`;
          }
        }
      },
      setSameQ: throttle(
        function (item) {
          if (!this.checkLogin()) {
            return;
          }
          const qaServer = useQaServer();
          if (this.joinId == item.join_id) {
            this.$message.warning(this.$t('chat.chat_1102'));
            return;
          }
          qaServer
            .setSameQ({
              question_id: item.id,
              like_status: item.like_status == 1 ? '0' : '1'
            })
            .then(res => {
              if (res.code == 200) {
                this.showEffect = true;
                setTimeout(() => (this.showEffect = false), 500);
                return;
              }
              if ([513036, 513018].includes(res.code)) {
                this.$message.error(this.$t('chat.chat_1101'));
                return;
              }
              if (res.code == 513128) {
                this.$message.warning(this.$t('common.common_1041'));
              }
            });
        },
        500,
        { trailing: false }
      )
    }
  };
</script>

<style lang="less" scoped>
  .vhsaas-chat-msg-item {
    padding: 20px 12px 0;
    display: flex;
  }
  .vhsaas-chat-msg-item__avatar {
    width: 28px;
    height: 28px;
    border-radius: 14px;
    overflow: hidden;
    .msg-item__avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .vhsaas-chat-msg-item__content {
    flex: 1;
    padding-left: 10px;
    word-break: break-all;
    &.reply .msg-item__content-body__content {
      color: var(--theme-tab-content-qa-text-font);
    }
  }
  .msg-item_content-name-nick {
    float: left;
    max-width: 170px;
    font-size: 14px;
    color: var(--theme-tab-content-qa-text-font);
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .msg-item_content-name-role {
    float: left;
    padding: 0 4px;
    margin-left: 8px;
    font-size: 12px;
    line-height: 16px;
    background-color: rgba(251, 58, 50, 0.2);
    border-radius: 9px;
    &.host {
      color: var(--qa-role-name-host-text);
      background-color: var(--qa-role-name-host-bg);
    }
    &.assistant {
      color: var(--qa-role-name-assistant-text);
      background-color: var(--qa-role-name-assistant-bg);
    }
    &.guest {
      color: var(--qa-role-name-assistant-text);
      background-color: var(--qa-role-name-assistant-bg);
    }
  }
  .msg-item__content-time {
    float: right;
    font-size: 14px;
    color: var(--theme-tab-content-qa-text-font);
    line-height: 16px;
  }
  .msg-item__content-body__content-wrapper {
    margin-top: 8px;
    background: #222222;
    border-radius: 4px;
    padding: 6px;
  }
  .msg-item__content-body__content {
    margin-top: 4px;
    font-size: 14px;
    color: var(--theme-tab-content-qa-replyText-font);
    line-height: 20px;
    word-break: break-word;
    overflow: hidden;
    &.reply-msg {
      margin-top: 0;
    }
    &::v-deep .reply-msg__nick-name {
      color: @font-dark-low;
    }
    &::v-deep .reply-msg__label {
      color: #fc9600;
      float: left;
    }
    ::v-deep .msg-item__qa-flag {
      color: #fc9600;
      float: left;
      &.color-e6e {
        color: var(--theme-tab-content-qa-replyText-font);
      }
    }
  }
  .msg-item__content-hr {
    width: 100%;
    height: 8px;
    float: left;
    clear: left;
  }
  ::v-deep .msg-item__content-body__content-link {
    color: @font-link;
    text-decoration: underline @font-link;
  }
  .vhsaas-msg-item__qa-content {
    display: flex;
    background: var(--theme-tab-content-qa-replyText-bg);
    border-radius: 4px;
    padding: 6px;
    clear: left;
  }
  .msg-content_same {
    text-align: right;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    color: var(--theme-tab-content-qa-replyText-font);
    padding-top: 4px;
    &.active {
      color: #fb2626;
    }
    i {
      font-size: 14px;
    }
    .same_count {
      cursor: pointer;
      position: relative;
      &.disabled {
        cursor: default;
      }
      i {
        line-height: 14px;
      }
      .normal-like {
        position: relative;
        .effect-like {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          transform: scale(0);
          &.active {
            transform: scale(1);
            transition: all 0.5s;
          }
        }
      }
      .effect {
        position: absolute;
        left: 0;
        top: -10px;
        color: #fb2626;
        opacity: 0;
        font-weight: normal;
        &.active {
          animation: add-one 0.5s linear 1;
        }
      }
    }
  }
  @keyframes add-one {
    0% {
      opacity: 0;
      transform: translateY(0);
    }
    30% {
      opacity: 1;
      transform: translateY(-5px);
    }
    100% {
      opacity: 0;
      transform: translateY(-15px);
    }
  }
</style>
